<div class="row">
  <div class="offset-lg-3 col-lg-6 col-12">
    <div class="card border-danger rounded-0 mb-3">
      <div class="card-body text-danger">
        <h4 class="card-title">{{ "GAST-PORTAL-NG.SOMETHING_WENT_WRONG.TITLE" | translate }}</h4>
        <p>{{ "GAST-PORTAL-NG.SOMETHING_WENT_WRONG.TEXT" | translate }}</p>
        @if (backUrl() !== undefined) {
          <a role="button" [routerLink]="[backUrl()]">{{ backLabel() | translate }}</a>
        }
      </div>
    </div>
  </div>
</div>
